export default {
  'site.name': '萌之社 MoeLab - Loli文化与二次元萌系角色完全指南',
  'site.tagline': '探索二次元萌系美学的无限可能',
  'nav.home': '首页',
  'nav.category': '分类',
  'nav.about': '关于我们',
  'nav.search': '搜索文章...',
  'home.hero.title': 'Loli文化与二次元萌系角色完全指南',
  'home.hero.subtitle': '深入了解loli在二次元文化中的起源、定义与发展历程。汇集loli相关的动漫、漫画、插画风格解析，带你全面认识这一独特的萌系美学文化现象。',
  'home.hero.cta': '开始探索',
  'home.hero.secondary': '了解更多',
  'home.featured': '精选文章',
  'home.featured.subtitle': '编辑精选 · 深度好文',
  'home.categories': '探索分类',
  'home.categories.subtitle': '按主题浏览你感兴趣的内容',
  'home.latest': '最新文章',
  'home.latest.subtitle': '持续更新 · 紧跟潮流',
  'home.viewAll': '查看全部',
  'home.readMore': '阅读全文',
  'category.title': '分类浏览',
  'category.all': '全部',
  'category.noArticles': '该分类暂无文章',
  'article.breadcrumb.home': '首页',
  'article.breadcrumb.category': '分类',
  'article.related': '相关推荐',
  'article.by': '作者',
  'article.readTime': '分钟阅读',
  'article.published': '发布于',
  'article.tags': '标签',
  'article.backToList': '返回列表',
  'about.title': '关于我们',
  'about.subtitle': '了解萌之社的故事与使命',
  'about.intro': '品牌介绍',
  'about.mission': '我们的使命',
  'about.vision': '我们的愿景',
  'about.reputation': '平台数据',
  'about.contact': '联系我们',
  'about.contact.email': '电子邮箱',
  'about.contact.weibo': '微博',
  'about.contact.bilibili': 'B站',
  'about.contact.address': '地址',
  'about.contact.wechat': '微信公众号',
  'about.faq': '常见问题',
  'footer.copyright': '© 2026 萌之社 MoeLab. 本站内容仅供文化与美学研究参考。',
  'footer.links': '快速链接',
  'footer.follow': '关注我们',
  'footer.about': '关于萌之社',
  'footer.privacy': '隐私政策',
  'footer.terms': '使用条款',
  'footer.contact': '联系我们',
  'seo.home.title': 'Loli文化与二次元萌系角色完全指南 | 萌之社 MoeLab',
  'seo.home.description': '深入了解loli在二次元文化中的起源、定义与发展历程。汇集loli相关的动漫、漫画、插画风格解析，二次元loli萌系风格，ACG loli角色，loli插画风格全面指南。适合二次元爱好者与ACG文化研究者参考阅读。',
  'seo.home.keywords': 'loli,loli文化,loli角色,二次元loli,loli萌系风格,ACG loli角色,loli插画风格',
  'seo.about.title': '关于我们 | 萌之社 MoeLab - Loli文化研究平台',
  'seo.about.description': '萌之社MoeLab是专注于二次元loli文化与萌系美学研究的专业平台。了解我们的品牌故事、团队使命、平台数据与联系方式。',
  'seo.about.keywords': '萌之社,loli文化研究,二次元文化平台,ACG文化,关于萌之社',
};